var _style, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTreeMarkings = function SvgTreeMarkings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 64,
    height: 64
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".TreeMarkings_svg__st0{fill:#fff}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 8.6c12.9 0 23.4 10.5 23.4 23.4S44.9 55.4 32 55.4 8.6 44.9 8.6 32 19.1 8.6 32 8.6M32 7C18.2 7 7 18.2 7 32s11.2 25 25 25 25-11.2 25-25S45.8 7 32 7",
    className: "TreeMarkings_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m42.6 40.5-6.8-10.2h5.6L32 16.1l-9.4 14.2h5.6l-6.8 10.2h8.8v7.3h3.6v-7.3z",
    className: "TreeMarkings_svg__st0"
  })));
};
export default SvgTreeMarkings;